import styles from './LoginPage.module.css';
import BrandPanel from '../components/login/BrandPanel';
import LoginForm from '../components/login/LoginForm';

const LoginPage = () => {
  return (
    <div className={styles.page}>
      {/* Left Column */}
      <div className={styles.leftCol}>
        <BrandPanel />
      </div>

      {/* Right Column */}
      <div className={styles.rightCol}>
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
